module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/9ft-mobile-db75b943f780cac22c4c7d6e418ffdbd.png";